import { render, staticRenderFns } from "./productHistory.vue?vue&type=template&id=684b57a1&"
import script from "./productHistory.vue?vue&type=script&lang=js&"
export * from "./productHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports